// removed by extract-text-webpack-plugin
module.exports = {"consolis_blau":"#004e8f","consolis_grau":"#72797f","consolis_burgund":"#5b6693","consolis_burgund_light":"#7d88b4","consolis_schwarz":"black"};


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = 63
// module chunks = 0